/* eslint-disable max-len */
/* eslint-disable implicit-arrow-linebreak */
import { FunctionComponent } from 'react';
import { Route } from 'react-router-dom';

import AllTransaction from './CanadaRent/AllTransactions';
import PendingTransaction from './CanadaRent/PendingTransaction';
import SuccessfulTransaction from './CanadaRent/SuccessfulTransaction';
import FailedTransaction from './CanadaRent/FailedTransaction';
import { AdminRouteName } from '../CONSTANTS';
import DashboardWrap from '../../components/DashboardWrap';

import './CanadaRent/Transaction.scss';

const Transactions: FunctionComponent = () =>

  (

    <DashboardWrap>
      <Route component={AllTransaction} exact path={AdminRouteName.transactionRoute} />
      <Route component={PendingTransaction} path={AdminRouteName.pendingTransactionRoute} />
      <Route component={SuccessfulTransaction} path={AdminRouteName.successfulTransactionRoute} />
      <Route component={FailedTransaction} path={AdminRouteName.failedTransactionRoute} />

    </DashboardWrap>

  );
export default Transactions;
